/**
 * Enum for Columns text alignment.
 */
export enum ColumnTextAlign {
	Left = "left",
	Center = "center",
	Right = "right"
}
